import { Create, ListButton, TopToolbar } from 'react-admin';

import ChevronLeft from '@material-ui/icons/ChevronLeft';

import ContactTypeForm from './ContactTypeForm';

const ContactTypeActions = ({ basePath }: any) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const ContactTypeCreate = (props: any) => {
  return (
    <Create actions={<ContactTypeActions {...props} />} {...props}>
      <ContactTypeForm />
    </Create>
  );
};

export default ContactTypeCreate;
